import { useEffect, useRef, useSyncExternalStore } from "react"

import { useLocation } from "react-router-dom"

import { useOnboardingMilestone } from "@/entities/onboarding"

import { getActiveOnboardingSessionToken, subscribeOnboardingSession } from "@/shared/lib/onboarding-session"

export const OnboardingFlowTracker: React.FC = () => {
  const location = useLocation()
  const reportMilestone = useOnboardingMilestone()
  const reportedScreens = useRef(new Set<string>())
  const sessionToken = useSyncExternalStore(subscribeOnboardingSession, getActiveOnboardingSessionToken)

  useEffect(() => {
    if (!sessionToken) return

    const key = `${sessionToken}:${location.pathname}`
    if (reportedScreens.current.has(key)) return
    reportedScreens.current.add(key)

    reportMilestone("screen_viewed", { screen: location.pathname })
  }, [sessionToken, location.pathname, reportMilestone])

  useEffect(() => {
    const handleClick = (event: MouseEvent) => {
      const target = event.target
      if (!(target instanceof Element)) return

      const actionElement = target.closest<HTMLElement>("[data-ob-action]")
      const action = actionElement?.dataset.obAction
      if (!action) return

      reportMilestone("action_taken", {
        action,
        screen: window.location.pathname
      })
    }

    document.addEventListener("click", handleClick, true)
    return () => {
      document.removeEventListener("click", handleClick, true)
    }
  }, [reportMilestone])

  return null
}
